import { FC } from 'react';

import { useGoToHome } from '@dbt-labs/app-nav';
import { Icon, Link, RyeconMagnifyingGlass } from '@dbt-labs/sourdough';

export const NotFoundPage: FC = () => {
  const { goToHome } = useGoToHome();
  return (
    <div className="mt-20 flex flex-col items-center justify-center">
      <Icon
        ryecon={RyeconMagnifyingGlass}
        size="lg"
        className="mb-8 text-fgDecorative"
      />
      <h1 className="mb-2 text-4xl text-fgMain">404: Page not found</h1>
      <p className="text-lg text-fgMain">
        Try going{' '}
        <Link to="/" isInternal={false} onClick={() => goToHome()}>
          home
        </Link>
      </p>
    </div>
  );
};
